import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import App from "./app/app";
import { Toaster } from "react-hot-toast";
import Blogs from "./app/blogs";
import AddUpdateBlogs from "./app/blogs/addUpdateBlogs";
import CaseStudy from "./app/caseStudy";
import Leads from "./app/leads";
import Jobs from "./app/job";
import Applicants from "./app/applicants";
import Technology from "./app/technology";
import Solutions from "./app/solutions";
import Products from "./app/products";
import Industries from "./app/industries";
import Compliance from "./app/compliance";
import AddUpdateCaseStudy from "./app/caseStudy/addUpdateCaseStudy";
import AddUpdateJob from "./app/job/addUpdateJob";
import AddUpdateTechnology from "./app/technology/addUpdateTechnology";
import AddUpdateSolutions from "./app/solutions/addUpdateSolutions";
import AddUpdateIndustries from "./app/industries/addUpdateIndustries";
import AddUpdateCompliance from "./app/compliance/addUpdateCompliance";
import Home from "./app/home/home";
import AddUpdateHomeCarousel from "./app/home/addUpdateHomeCarousel";
import AddUpdateGridSection from "./app/home/addUpdateGridSection";
import AddUpdateNumbers from "./app/home/addUpdateNumbers";
import AddUpdateClient from "./app/home/addUpdateClient";
import StaffAugmentation from "./app/staff-augmentation";
import DedicatedTeams from "./app/dedicated-teams";
import SoftwareOutsourcing from "./app/software-outsourcing";
import AddUpdateStaffAugmentationHero from "./app/staff-augmentation/addUpdateStaffAugmentationHero";
import AddUpdateDedicatedTeamsHero from "./app/dedicated-teams/addUpdateDedicatedTeamsHero";
import AddUpdateSoftwareOutsourcingHero from "./app/software-outsourcing/addUpdateSoftwareOutsourcingHero";
import AddUpdateProducts from "./app/products/addUpdateProducts";
import Career from "./app/career";
import AddUpdateHeroCareer from "./app/career/AddUpdateHeroCareer";
import About from "./app/about";
import AddUpdateAboutHero from "./app/about/AddUpdateAboutHero";
import Service from "./app/service";
import TechnologyPage from "./app/technology_page";
import SolutionsPage from "./app/solutions-page";
import IndustryPage from "./app/industry-page";
import ProductsPage from "./app/productsPage";
import Settings from "./app/settings";

const root = ReactDOM.createRoot(document.getElementById("root"));

const Main = () => {
  const router = createBrowserRouter([
    {
      path: "",
      element: <App />,
      children: [
        { path: "/", element: <Home /> },
        { path: "/home-carousel/:id", element: <AddUpdateHomeCarousel /> },
        { path: "/home-carousel/add", element: <AddUpdateHomeCarousel /> },
        { path: "/grid-section/:id", element: <AddUpdateGridSection /> },
        { path: "/grid-section/add", element: <AddUpdateGridSection /> },
        { path: "/number/add", element: <AddUpdateNumbers /> },
        { path: "/number/:id", element: <AddUpdateNumbers /> },
        { path: "/client/add", element: <AddUpdateClient /> },
        { path: "/client/:id", element: <AddUpdateClient /> },
        { path: "/staff-augmentation", element: <StaffAugmentation /> },
        {
          path: "/staff-augmentation/hero/:id",
          element: <AddUpdateStaffAugmentationHero />,
        },
        {
          path: "/staff-augmentation/hero/add",
          element: <AddUpdateStaffAugmentationHero />,
        },
        { path: "/dedicated-teams", element: <DedicatedTeams /> },
        {
          path: "/dedicated-teams/hero/:id",
          element: <AddUpdateDedicatedTeamsHero />,
        },
        {
          path: "/dedicated-teams/hero/add",
          element: <AddUpdateDedicatedTeamsHero />,
        },
        { path: "/software-outsourcing", element: <SoftwareOutsourcing /> },
        {
          path: "/software-outsourcing/hero/:id",
          element: <AddUpdateSoftwareOutsourcingHero />,
        },
        {
          path: "/software-outsourcing/hero/add",
          element: <AddUpdateSoftwareOutsourcingHero />,
        },
        {
          index: true,
          path: "/blogs",
          element: <Blogs />,
        },
        { path: "/blogs/add", element: <AddUpdateBlogs /> },
        { path: "/blogs/:id", element: <AddUpdateBlogs /> },
        { path: "/case-study", element: <CaseStudy /> },
        { path: "/case-study/add", element: <AddUpdateCaseStudy /> },
        { path: "/case-study/:id", element: <AddUpdateCaseStudy /> },
        { path: "/leads", element: <Leads /> },
        { path: "/jobs", element: <Jobs /> },
        { path: "/jobs/add", element: <AddUpdateJob /> },
        { path: "/jobs/:id", element: <AddUpdateJob /> },
        { path: "/applicants", element: <Applicants /> },
        { path: "/technology", element: <Technology /> },
        { path: "/technology/add", element: <AddUpdateTechnology /> },
        { path: "/technology/:id", element: <AddUpdateTechnology /> },
        { path: "/solutions", element: <Solutions /> },
        { path: "/solutions/add", element: <AddUpdateSolutions /> },
        { path: "/solutions/:id", element: <AddUpdateSolutions /> },
        { path: "/products-page", element: <ProductsPage /> },
        { path: "/products", element: <Products /> },
        { path: "/products/add", element: <AddUpdateProducts /> },
        { path: "/products/:id", element: <AddUpdateProducts /> },
        { path: "/industries", element: <Industries /> },
        { path: "/industries/add", element: <AddUpdateIndustries /> },
        { path: "/industries/:id", element: <AddUpdateIndustries /> },
        { path: "/compliance", element: <Compliance /> },
        { path: "/compliance/add", element: <AddUpdateCompliance /> },
        { path: "/compliance/:id", element: <AddUpdateCompliance /> },
        { path: "/career", element: <Career /> },
        { path: "/career/hero/:id", element: <AddUpdateHeroCareer /> },
        { path: "/career/hero/add", element: <AddUpdateHeroCareer /> },
        { path: "/about", element: <About /> },
        { path: "/about/hero/:id", element: <AddUpdateAboutHero /> },
        { path: "/about/hero/add", element: <AddUpdateAboutHero /> },
        { path: "/service", element: <Service /> },
        { path: "/technology-page", element: <TechnologyPage /> },
        { path: "/solutions-page", element: <SolutionsPage /> },
        { path: "/industry-page", element: <IndustryPage /> },
        { path: "/settings", element: <Settings /> },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};
//test
root.render(
  <>
    <Toaster />
    <Main />
  </>
);
